import type { Role } from "@datamole/lssa-permissions";
import { unique } from "radash";

import { roleToViewMap } from "@/features/views/role-view-map";
import type { View } from "@/features/views/view-definitions";

export const getGrantedViewsFromRoles = (roles: Role[]): View[] => {
    return unique(
        roles.flatMap((role) => roleToViewMap[role] ?? []),
        (viewId) => viewId,
    );
};

export const resolveActiveView = (assignedRoles: Role[], persistedActiveView: string | null): View | null => {
    const grantedViewIds = getGrantedViewsFromRoles(assignedRoles);

    // Parses opaque string to View type if it is among the granted views
    const isGrantedView = (view: string): view is View => grantedViewIds.includes(view as View);
    if (persistedActiveView && isGrantedView(persistedActiveView)) {
        return persistedActiveView;
    }

    // Fall back to first granted view if persisted active view is not valid or not present
    if (grantedViewIds.length > 0) {
        return grantedViewIds[0];
    }

    return null;
};

export const validateViewType = (view: unknown): view is View => {
    return Object.keys(roleToViewMap).some((role) => roleToViewMap[role as Role].includes(view as View));
};
